import { ProductDetailPage } from '../pages/ProductDetailPage';

export function ResponsiveProductDetailPage() {
  return <ProductDetailPage />;
}
